import { Emitter } from './utils/emitter';

var appEvents = new Emitter();
export default appEvents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/app_events.ts